export const SERVICE_USER_ROLE_PM = 'pm';
export const SERVICE_USER_ROLE_INTEGRATOR = 'integrator';
export const SERVICE_USER_ROLE_EX_STAFF = 'ex-staff';
export const SERVICE_USER_ROLE_OTHER = 'other';
export const SERVICE_USER_ROLE_ACCOUNTING_REPRESENTATIVE = 'accounting-representative';
export const SERVICE_USER_ROLE_OPERATIONS_MANAGER = 'operations-manager';
export const SERVICE_USER_ROLE_OPERATIONS_ENGINEER = 'operations-engineer';
export const SERVICE_USER_ROLE_SOLUTIONS_ENGINEER = 'solutions-engineer';
export const SERVICE_USER_ROLE_ACCOUNT_MANAGER = 'account-manager';

export const SERVICE_USER_ROLE_VALUES = Object.freeze([SERVICE_USER_ROLE_PM, SERVICE_USER_ROLE_INTEGRATOR, SERVICE_USER_ROLE_EX_STAFF, SERVICE_USER_ROLE_OTHER, SERVICE_USER_ROLE_ACCOUNTING_REPRESENTATIVE, SERVICE_USER_ROLE_OPERATIONS_MANAGER, SERVICE_USER_ROLE_OPERATIONS_ENGINEER, SERVICE_USER_ROLE_SOLUTIONS_ENGINEER, SERVICE_USER_ROLE_ACCOUNT_MANAGER]);

export const SERVICE_USER_PM_ASSIGNABLE_ROLES = Object.freeze([SERVICE_USER_ROLE_PM, SERVICE_USER_ROLE_OPERATIONS_MANAGER]);

export const SERVICE_USER_MONITORING_WORK_ROLES = Object.freeze([SERVICE_USER_ROLE_INTEGRATOR, ...SERVICE_USER_PM_ASSIGNABLE_ROLES]);

export const isServiceUserPmAssignableRole = (role) => {
  return SERVICE_USER_PM_ASSIGNABLE_ROLES.includes(role);
};

export const isServiceUserMonitoringWorkRole = (role) => {
  return SERVICE_USER_MONITORING_WORK_ROLES.includes(role);
};
